export const ACCOUNT_TYPE = {
    INSTRUCTOR: 'Instructor',
    STUDENT: 'Student',
    ADMIN: 'Admin' 
}